import { render, staticRenderFns } from "./GreetingBubble.vue?vue&type=template&id=22d3fc30"
import script from "./GreetingBubble.vue?vue&type=script&lang=js"
export * from "./GreetingBubble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports